import { REQUEST_TYPE_SUFFIXES, PROMISE_TYPE_DELIMITER } from '../actions/actionTypes'
import actionAsObjectMiddleware from './actionAsObject';
// import promise from './promise.js';
import promiseMiddleware from 'redux-promise-middleware';
// import { apiMiddleware } from 'redux-api-middleware';
import { apiMiddleware } from './api';
import GoogleTagManagerMiddleware from './GoogleTagManagerMiddleware';
import thunk from 'redux-thunk';


export default function appMiddleware(httpProps){
  return [
    // api(httpProps),
    apiMiddleware(),
    actionAsObjectMiddleware,
    promiseMiddleware({promiseTypeSuffixes: REQUEST_TYPE_SUFFIXES, promiseTypeDelimiter: PROMISE_TYPE_DELIMITER}),
    thunk,
    GoogleTagManagerMiddleware()
  ]
}


// WEBPACK FOOTER //
// ./src/middleware/index.js